import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { IThemeDTO } from '../../../api/themes.dao';
import { ThemeFormVM } from './theme-form.viewmodel';
import { ThemeFormPresentation } from './_theme-form-presentation/theme-form-presentation';

interface IProps {
    fetchThemeList: () => void;
    theme?: IThemeDTO;
}

const ThemeFormContainer = withViewModel(
    ThemeFormPresentation,
    (props: IProps) => {
        const { fetchThemeList, theme } = props;
        const themeFormVM = new ThemeFormVM(fetchThemeList, theme);
        return themeFormVM;
    }
);

export { ThemeFormContainer as ThemeForm };
